<template>
  <div v-if="currentChantier">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-8">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Nom chantier</span>
                  </td>
                  <td>
                    {{ currentChantier.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Code chantier</span>
                  </td>
                  <td>
                    {{ currentChantier.code_chantier }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Sociéte</span>
                  </td>
                  <td>
                    {{ currentChantier.societe }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Commercial</span>
                  </td>
                  <td>
                    {{ currentChantier.commercial }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Inspecteur</span>
                  </td>
                  <td>
                    {{ currentChantier.inspecteur }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Client</span>
                  </td>
                  <td>
                    {{ currentChantier.client }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Récurrent</span>
                  </td>
                  <td>
                    {{ currentChantier.recurrence ? 'Oui' : 'Non' }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Périodicité</span>
                  </td>
                  <td>
                    {{ currentChantier.periodicite }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Montant</span>
                  </td>
                  <td>
                    {{ currentChantier.montant }}
                  </td>
                </tr>

                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td>
                    {{ currentChantier.auteur }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 col-lg-4">
          <div
            class="bg-white py-2 mb-2 d-flex flex-column align-items-center justify-content-center"
          >
            <span class="py-2"
              ><i class="fa fa-info-circle text-custom-primary"></i>
              <span class="font-weight-bold"> Adresse</span></span
            >
            <p>{{ currentChantier.adresse }}</p>
          </div>
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Pays</span>
                  </td>
                  <td>
                    {{ currentChantier.pays }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Ville</span>
                  </td>
                  <td>
                    {{ currentChantier.ville }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Code postal</span>
                  </td>
                  <td>
                    {{ currentChantier.code_postal }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-phone text-custom-primary"></i>
                    <span class="font-weight-bold"> Téléphone</span>
                  </td>
                  <td>
                    {{ currentChantier.telephone }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      title: 'Gestion tiers - Détails',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  computed: {
    ...mapGetters('chantier', ['currentChantier']),
  },
  methods: {
    ...mapActions('chantier', ['getChantier']),
    init() {
      this.getChantier(this.$route.params.id);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
